import axiosInterceptor from '../../interceptor/axiosClient';
import { PasswordData } from '../types';

export const newPassword = async (newPasswordData: PasswordData) => {
  const data = await axiosInterceptor.post('reset-password-complete/', newPasswordData, {});

  return data.data;
};
